import type {colors} from '@/theme'

type TagColors = keyof typeof colors.tag

export const isValidTagColor = (value: string): value is TagColors =>
    ['grey', 'yellow', 'pink', 'purple', 'blue', 'green', 'red'].includes(value)
